module.exports = __webpack_public_path__ + "img/Support-08.5578902f.svg";